import {artworkResultsHref} from './artworkDirectory.js'
// A global search must leave direct-account/championship launch routes, while
// retaining the user's saved filters and return-to-Command-Center context.
export function artworkSearchHref(params) {
  const next=new URLSearchParams(params)
  next.delete('account')
  next.delete('championship')
  return artworkResultsHref(next)+'#artwork-search'
}
